module.exports = __webpack_public_path__ + "media/slider/Subscription-2-US-51a28704.jpg";